import {Announcement} from '@shopify/marketing-assets';

import '@shopify/brochure2/application';

(function() {
  const announcement = document.querySelector('.js-announcement');
  if (announcement) {
    new Announcement(announcement); // eslint-disable-line no-new
  }
})();
